export const GET_USER_DATA = 'GET_USER_DATA'
export const GET_USER_DATA_EXITO = 'GET_USER_DATA_EXITO'
export const GET_USER_DATA_ERROR = 'GET_USER_DATA_ERROR'
